import React from 'react';

import PhonePaused from '@material-ui/icons/PhonePaused';

export const OnHoldIcon = () => <PhonePaused />;
